import { HrmRequestFormResponse } from '@Types/api/form';
import { RequestListSearchResponse } from '@Types/api/requestList';
import { parseDateTime } from '@Utils/transformDateTime';
import { transformFlagsToOption } from '@Utils/transformToOptions';
import { TypeDict } from 'types';
import { ColumnDataType } from './type';

export const dataSourceMap = (
  data: RequestListSearchResponse<HrmRequestFormResponse>,
  findStatus: (statusNum: number) => TypeDict | undefined,
  findLeaveType: (statusNum: number) => TypeDict | undefined
): Array<ColumnDataType> => {
  if (!data?.content) return [];

  return data?.content?.map((requestItem) => ({
    key: requestItem.requestId,
    requestNo: requestItem.requestId,
    empNumber: requestItem.empNumber,
    empName: requestItem.empName,
    approverName: requestItem.approverName,
    leaveType: findLeaveType(requestItem.leaveTypeID)?.codeDesc || '',
    startDate: parseDateTime(requestItem.startDate),
    endDate: parseDateTime(requestItem.endDate),
    totDays: requestItem.totDays,
    ticketRequired: transformFlagsToOption(Boolean(requestItem.ticketRequired))
      .label,
    passportRequired: transformFlagsToOption(
      Boolean(requestItem.passportRequired)
    ).label,
    createdDate: parseDateTime(requestItem.createdDate),
    status: findStatus(requestItem.reqStatusId)?.codeDesc || '',
    action: '',
  }));
};
